import { FormattedMessage } from 'react-intl';

import { DateInput } from '../../../../forms/dateInput/index';

export const TradingFromQuestion = (props) => {
    const { onChange } = props;

    return (
        <DateInput
            label={
                <FormattedMessage
                    id="_.your_company.business_trading"
                    defaultMessage="When did your business start trading?"
                />
            }
            onChange={onChange}
            name="tradingFrom"
            id="tradingFrom"
        />
    );
};
